import { observer } from "mobx-react";
import * as React from "react";
import { AppStore } from "../../stores/AppStore";
import { observable } from "mobx";
import { Tab, Tabs } from "@blueprintjs/core";
import HistoricoNotasPage from "./Manifestacoes";
import CalculoManifestacoes from "./CalculoManifestacoes";
import { ManifestacoesStore } from "../../stores/manifestacoes/ManifestacoesStore";

@observer
export default class ManifestacoesPage extends React.Component<{}, {}> {

    obs = observable({
        selectedTab: "manifestacoes" as string
    })

    constructor(props: any) {
        super(props);
    }

    componentDidMount() {
        AppStore.setTitle("Manifestações");
    }

    handldeChargeTab(tabId) {
        ManifestacoesStore.obs.calcularItems = []
        ManifestacoesStore.handleConsultaTodas(1, 15);
        ManifestacoesStore.handldeItensProcessando();
        this.obs.selectedTab = String(tabId)
    }

    render() {
        return (
            <Tabs
                id="tabs"
                className={"tabsCalculos"}
                selectedTabId={this.obs.selectedTab}
                onChange={(tabId) => this.handldeChargeTab(tabId)}
                data-tut="resumo"
            >
                <Tab
                    id="manifestacoes"
                    title="Manifestações"
                    panel={
                        <HistoricoNotasPage />
                    }
                />

                <Tab
                    id="calculos"
                    title="Cálculo Manifestações"
                    panel={
                        <CalculoManifestacoes />
                    }
                />
            </Tabs>
        )
    }
}